import React from 'react';
import { func, instanceOf } from 'prop-types';

import IconButton from '@material-ui/core/IconButton';
import Popover from '@material-ui/core/Popover';

import IconMoreHorz from '../../shared/icons/IconMoreHorz';
import IconDelete from '../../shared/icons/IconDelete';

const ContextMenu = ({ row, onClick, handleRowClick }) => {
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = event => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
    handleRowClick(null, true)
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleAction = (event, row) => {
    handleClose();
    onClick(event.target.textContent, row);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  return (
    <div className="de--campaign--context-menu">
      <IconButton
        aria-describedby={id}
        className="ct--col__actions--button"
        aria-controls="simple-menu"
        aria-haspopup="true"
        onClick={handleClick}
      >
        <IconMoreHorz />
      </IconButton>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        className="de--campaign--context-popover"
      >
        <div className="de--campaign--context-root">
          { row.atd === 1 &&
            <button
              type="button"
              onClick={e => handleAction(e, row)}
              className="de--campaign--context-item"
              data-test="edit"
            >
              <span>Edit</span>
            </button>
          }
          <button
            type="button"
            onClick={e => handleAction(e, row)}
            className="de--campaign--context-item"
            data-test="duplicate"
          >
            <span>Duplicate</span>
          </button>
          <button
            type="button"
            onClick={e => handleAction(e, row)}
            className="de--campaign--context-item"
            data-test="label"
          >
            <span>Label</span>
          </button>
          <button
            type="button"
            onClick={e => handleAction(e, row)}
            className="de--campaign--context-item"
            data-test="distibute"
          >
            <span>Distribute</span>
          </button>
          <button
            type="button"
            onClick={e => handleAction(e, row)}
            className="de--campaign--context-item"
            data-test="export"
          >
            <span>Export</span>
          </button>
          { row.atd === 1 &&
            <button
              type="button"
              onClick={e => handleAction(e, row)}
              className="de--campaign--context-item de--campaign--context-delete"
              data-test="delete"
            >
              <span>Delete</span>
              <IconDelete/>
            </button>
          }
        </div>
      </Popover>
    </div>
  );
};

ContextMenu.propTypes = {
  row: instanceOf(Object),
  onClick: func,
  handleRowClick: func,
};

export default ContextMenu;
